export default __webpack_public_path__ + "static/media/page_oxe_tech_lab.63762fca.jpg";